import { buildApiActionTypes } from './apiActionTypes';

export const getCurrentTermsOfServiceActionTypes = buildApiActionTypes(
  'GET_CURRENT_TERMS_OF_SERVICE'
);
